// extracted by mini-css-extract-plugin
module.exports = {"resume_wrapper":"resume_resume_wrapper__dRalb","resume_list":"resume_resume_list__17GE0"};